import {Accordion as BootstrapAccordion} from "react-bootstrap";
import * as React from "react";
import {ProductRatings} from "../../../userContent/productRatings";
import {StarRating} from "../../../../../components/starRating";
import {useRatingsAccordionHeader} from "../../../../../hooks/useRatingsAccordionHeader";
import {useAccordionItemBodyStatus} from "../../../../../hooks/useAccordionItemBodyStatus";
import {useAccordionVariables} from "../../../../../hooks/useAccordionVariables";
import {AccordionItemType} from "../../../../../definitions/enums";
import {useAppContext} from "../../../../../hooks/useAppContext";
import {ErrorBoundary} from "@sentry/react";
import {ZeroRatings} from "../../../userContent/zeroRatings";

export const Ratings = () => {
    return (
        <ErrorBoundary fallback={<></>}>
            <Header/>
            <Body/>
        </ErrorBoundary>
    )
}

const Header = () => {
    const {onClick} = useAccordionVariables();
    const {title, hasSubTitle, count, grade} = useRatingsAccordionHeader();

    return (
        <BootstrapAccordion.Header className="fs-3" onClick={() => onClick(AccordionItemType.Reviews)}>
            <div className="d-flex align-items-start flex-column">
                <div className="me-2">{title}</div>
                {hasSubTitle && (
                    <div className="review-stars-wrap d-flex align-items-end flex-wrap">
                        <StarRating grade={grade}/>
                        <div className="review-text">
                            <strong className="review-ratings-total">{grade}</strong>
                            <span className="review-ratings-count">
                                {' '}out of <strong>5</strong> | ({count})
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </BootstrapAccordion.Header>
    )
}

const Body = () => {
    const {ratingCount} = useAppContext();
    const {hasEntered, onEnter} = useAccordionItemBodyStatus();

    return (
        <BootstrapAccordion.Body className="border-bottom" onEnter={onEnter}>
            {hasEntered && (!!(ratingCount && ratingCount > 0) ? <ProductRatings/> : <ZeroRatings/>)}
        </BootstrapAccordion.Body>
    );
};